import { ActivatedRouteSnapshot, CanActivateChildFn, RouterStateSnapshot } from '@angular/router';
import { tap } from 'rxjs';
import { AuthKeycloakService } from '../services.module/auth-keycloak.service';
import { inject } from '@angular/core';
import { filter, map } from 'rxjs/operators';

export const authKeycloakGuard: CanActivateChildFn = (
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const authService = inject(AuthKeycloakService);

    console.debug('Keycloak-Guard-Prüfung für URL ', state.url);

    return authService.isAuthenticatedSubject$.pipe(
        filter(isDone => isDone),
        tap(isAuthenticated => {
            if (!isAuthenticated) {
                authService.forceLogin();
            }
        }),
        map(isAuthenticated => isAuthenticated)
    );
};
